import { Alert, Link } from '@mui/material';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { DeveloperApiError } from './api';
import { describeError } from './components';
import { ERROR_CODES } from './labels';

/** Where a user sets two-step sign-in up (the user menu's Sign-in security). */
export const MFA_SETUP_PATH = '/account/security';

/** A refused sign-in: `mfa_required` says how to get an MFA session; the rest uses the Developer section's words. */
export const SigninError = ({ error }: { error: unknown }) => {
    if (!error) {
        return null;
    }
    if (error instanceof DeveloperApiError && error.code === 'mfa_required') {
        return (
            <Alert severity="warning" sx={{ mt: 1.5 }} data-testid="sandbox-mfa-required">
                {ERROR_CODES.mfa_required}{' '}
                <Link component={RouterLink} to={MFA_SETUP_PATH}>Set up two-step sign-in</Link>
            </Alert>
        );
    }
    return <Alert severity="error" sx={{ mt: 1.5 }} data-testid="sandbox-signin-error">{describeError(error)}</Alert>;
};
